import _ from 'lodash'

import { getBasketItemByEventId } from '../../../../../../components/Basket/helpers'
import Seat from '../../../../../../components/Seat/Seat'
import { TOP_OFFSET } from '../../constants'

import { getSeatDisabled, getSeatType } from './helpers'

import './GridSeats.scss'
import hocConnect from './hocConnect'

const GridSeats = ({ data, scaleFactor, selectedSeats, handleSeatClick, basket }) => {
    if (_.isEmpty(data)) return null

    const tickets = getBasketItemByEventId(basket)?.tickets ?? []

    return (
        <>
            {data?.map((seat) => {
                const seatY = seat?.y1
                const seatX = seat?.x1
                const width = seat.x2 - seat?.x1
                const height = seat.y2 - seat?.y1
                const isSelectedSeat = Boolean(
                    selectedSeats?.find((selectedSeat) => selectedSeat?.seatid === seat?.seatid)
                )
                const seatType = getSeatType(seat, tickets)
                const seatDisabled = getSeatDisabled(seat, seatType, isSelectedSeat, tickets)

                return (
                    <Seat
                        className={'hall-seating--seat'}
                        key={seat?.seatid}
                        style={{
                            top: `${seatY * scaleFactor + TOP_OFFSET}px`,
                            left: `${seatX * scaleFactor}px`,
                            transform: `rotate(${seat?.rotation}deg)`,
                            width: width * scaleFactor,
                            height: height * scaleFactor,
                        }}
                        disabled={seatDisabled}
                        isSelected={isSelectedSeat}
                        type={seatType}
                        size={seat?.group_seatid > 0 ? 'double' : 'single'}
                        onClick={() => handleSeatClick({ seat, isSelectedSeat, seatType })}
                    />
                )
            })}
        </>
    )
}

export default hocConnect(GridSeats)
